export default __webpack_public_path__ + "static/screeny-130-gpz-unica-m-3-2001e93a8e7f0db24d0c0bac9e7baa6d.jpg";